import type { Attribute } from '@core/http-types';
import type { DataTableColumn } from '@core/user-interface-legacy';

export type DepartmentAttribute = Attribute & { id: number };

export enum DepartmentsColumnId {
  Value = 'value',
  Count = 'count',
  JobsCount = 'jobs_count',
  TalentPoolsCount = 'talent_pools_count',
}

export type DepartmentsTableColumn = DataTableColumn<DepartmentsColumnId>;
